import { push } from "connected-react-router";

export function currentUtmParams(): string {
  const searchParams = new URLSearchParams(window.location.search);

  Array.from(searchParams.keys()).forEach(key => {
    if (!key.toLowerCase().startsWith("utm")) {
      searchParams.delete(key);
    }
  });

  return searchParams.toString();
}

export function preserveUTM(redirectTo: string): string {
  const searchParams = new URLSearchParams(window.location.search);

  Array.from(searchParams.keys()).forEach(key => {
    if (!key.toLowerCase().startsWith("utm")) {
      searchParams.delete(key);
    }
  });

  const toQueryParamPoint = redirectTo.indexOf("?");
  const toWithoutParams = toQueryParamPoint === -1 ? redirectTo : redirectTo.slice(0, toQueryParamPoint);
  const toQueryParams = new URLSearchParams(toQueryParamPoint === -1 ? "" : redirectTo.slice(toQueryParamPoint));
  toQueryParams.forEach((value, key) => {
    searchParams.append(key, value);
  });

  const searchParamsString = searchParams.toString();

  return `${toWithoutParams}${searchParamsString.length > 0 ? `?${searchParamsString}` : ""}`;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function pushWithUTM(to: string) {
  return push(preserveUTM(to));
}
